<template lang="pug">
  .yt
    div(v-if="!videoShown")
      img.thumb(:src='"//img.youtube.com/vi/"+link.url+"/"+currentImageResolution+".jpg"', @click="changeToYoutubeVideo", @load="testLoadedImage", ref="img")
      i.fa.fa-play.fa-2x
    .videoWrapper(v-if="videoShown")
      iframe(:src='"//www.youtube.com/embed/"+link.url+"?autoplay=1&modestbranding=1&hd=1&autohide=1&color=white"' frameborder="0" allowfullscreen allow="autoplay")  
</template>
<script type="text/javascript">
import $ from 'jquery'

export default {
  props: ['link'],
  data () {
    return {
      videoShown: false,
      currentImageResolution: 'maxresdefault'
    }
  },
  methods: {
    changeToYoutubeVideo () {
      this.videoShown = true
    },
    tryNextResolution () {
      this.currentImageResolution = 'hqdefault'
    },
    testLoadedImage () {
      if (($(this.$refs.img).prop('naturalHeight') <= 90) && ($(this.$refs.img).prop('naturalWidth') <= 120)) {
        return this.tryNextResolution()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// GroupPageLinkYoutube.vue?0620d32d